export type UserState = (typeof UserState)[keyof typeof UserState];

export const UserState = {
    InvitationPending: 'InvitationPending',
    InvitationExpired: 'InvitationExpired',
    Activated: 'Activated',
    Deactivated: 'Deactivated',
    Locked: 'Locked',
    Deleted: 'Deleted',
} as const;
